
window.AffiliationV2 = {
	
	initDashboard : function() {
		MyTabs.initHorizontal('affiliationv2');

		AffiliationV2.prepareInvoiceCallForm('invoiceCallFormY');
		AffiliationV2.prepareInvoiceCallForm('invoiceCallFormN');
		
		$('input[name=shortlink]').bind('click', function(){
			$(this).select();
		});

		AffiliationV2.animateProgression();
		
		AffiliationV2.prepareEmailForm('shareEmailForm');
		AffiliationV2.prepareLeadsForm('leadsFormDashboard');

		Qtip.init();
	},
	
	prepareEmailForm : function(formID){
		var inviteOpts = {
			dataType : 'json',
			data : {action : 'sendInviteEmail', formid : formID},
			success : function(data){
				var formok = MyForm.processJson(data, formID);
				if(formok){
					var msg  = Loc.g('Votre message a bien été envoyé aux emails suivant')+":<br /><br />"+data.emails.join(', ');
					MyWindow.alert(msg, {type : 'confirm'});
					$('#'+formID).find('.emailContent').slideUp();
					$('#'+formID).find('#share_emails').val("").trigger('blur');
					
				}
			}
		};
		
		MyForm.prepare(formID, 'affiliationv2', inviteOpts, false);
		
		$('#'+formID).find('#share_emails').bind('focus', function(){
			$(this).animate({height:'28px'}, 400);
			$('#'+formID).find('.emailContent').slideDown(400);
			MyFacture.customForm('#'+formID);
		});
		
	},
	
	prepareLeadsForm : function(formID){
		var inviteOpts = {
			dataType : 'json',
			data : {action : 'recordLeads', formid : formID},
			beforeSubmit : function(){
				MyFacture.startWait();
			},
			success : function(data){
				MyFacture.stopWait();
				var formok = MyForm.processJson(data, formID);
				if(formok){
					var msg  = Loc.g('Vos contacts ont bien été enregistrés.')+"<br /><br />"+Loc.g('Nous les contacterons sous peu de votre part.');
					MyWindow.alert(msg, {type : 'confirm'});
					$('#'+formID).find(':input').val("");
					$('#'+formID).find('.lead:not(:first)').fadeOut(400, function(){
						$(this).remove();
						
						if($('#'+formID+' .leads li').length <= 1){
							$('#'+formID+' .leads li .removeLead').hide();
						}
					});
				}
			}
		};
		
		MyForm.prepare(formID, 'affiliationv2', inviteOpts, false);
	},
	
	animateProgression : function(){
		var progression = $('.progression').attr('data-progression');
		var number = $('.progression').attr('data-number');
		$('.progression').show().animate({width : progression+'%'}, 1700, function(){
			
			$(this).find('.number').text(number).fadeIn(400);
		});
	},
	
	prepareFilterForm: function(){
        var options = {success:function(data){AffiliationV2.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("affiliatesFilterForm", "affiliationv2&action=updateAffiliatesListing", options);
    },
	
	processFilterForm: function(data){
		Listing.refresh("affiliatesListing", data, data.affiliates_metadatas);
	},
	
	prepareRemunerationsFilterForm: function(){
        var options = {success:function(data){AffiliationV2.processRemunerationsFilterForm(data);}, dataType:"json"};
        MyForm.prepare("remunerationsFilterForm", "affiliationv2&action=updateRemunerationsListing", options);
    },
	
	processRemunerationsFilterForm: function(data){
		Listing.refresh("remunerationsListing", data, data.remunerations_metadatas);
	},
	
	
	retailerCorpInfo : function(corpid){
		var options = {
			title	: Loc.g("Historique des paiements"),
			buttons	: {},
			width: 500
		};
		
		var fileOpt = {action:"retailerInfos", corpid : corpid};
//		fileOpt = $.extend(true, fileOpt);
		MyWindow.load("affiliation", fileOpt, options);
	},
	
	
	prepareInvoiceCallForm : function (formID){
        var options = {
			beforeSubmit : function(){
				MyFacture.startWait();
			},
			success : function(data){
				MyFacture.stopWait();
				
				var formIsOk = MyForm.processJson(data, formID);
				if(formIsOk) {
					$('#invoiceCall_step2').find('.totalAmount').html(data.amount);

					MyWindow.alert(Loc.g("Votre demande a bien été prise en compte")+". "+Loc.g("N’oubliez pas d’envoyer votre facture à parrainage@sellsy.com afin de recevoir votre paiement"));

					$('form#'+formID).fadeOut(300, function(){

						Listing.update('remunerationsListing', true);
						$('#invoiceCall_step2').fadeIn(300);

					});
				} else {
					var msg		=  data.form.msg ? data.form.msg : data.form.fields[0].msg;
					var options = {
						title		: Loc.g("Erreur système"),
						buttons		: [
							{text : Loc.g("Fermer"), click : function(){$(this).dialog("close");}}
						]
					};

					MyWindow.alert(msg, options);
				}
			}, 
			dataType : "json"
		};
	
	
        MyForm.prepare(formID, "affiliationv2&action=recordInvoiceCall", options);
		
		MyFacture.customForm("#"+formID);
	},
	
	emailAffiliate : function(template, corpid){
		
		var title = '';
		switch(template){
			case 'revive' : 
				title = Loc.g("Relancer le filleul");
				break;
			case 'webinar' : 
				title = Loc.g("Invitez votre filleul à regarder une démonstration");
				break;
		}
		
		
		var options = {
			title		: title,
			width		: 600,
			dialogClass	: 'newUI',
			buttons	: [
				{html : Loc.g('Envoyer'), click : function(){$('#emailForm').submit();}}
			],
			callback	: function(){
					var formOpt = {
						dataType : 'json',
						data : {action : 'sendEmailAffiliate', formid : 'emailForm'},
						success : function(data){
							var formok = MyForm.processJson(data, 'emailForm');
							if(formok){
								MyWindow.close();
								MyWindow.alert(Loc.g('Votre message a bien été envoyé !'), {type : 'confirm'});
							}
						}
					};

					MyForm.prepare('emailForm', 'affiliationv2', formOpt, false);
			}
		};

		var fileOpt = {
			action		: "emailAffiliate", 
			corpid		: corpid, 
			template	: template
		};
		
		
		MyWindow.load("affiliationv2", fileOpt, options);
	},
	
	addLead : function(formID){
		
		var $form		= $('#' + formID);
		
		var defaultCountryCode	= SmartPhoneNumber.getDefaultCountryCode($('#' + formID));
		var preferredCountries	= SmartPhoneNumber.getPreferredCountries(defaultCountryCode);
		
		var $newLead	= $($('#lead-tpl', $form).html());
		var newKey		= Math.ceil(Math.random() * 1000 + Math.random() * 100 + Math.random() * 10 +  + Math.random() * 1);
		
		$newLead.find('input').each(function(){
			
			var $input = $(this);
			
			$input.removeClass('ui-state-error');
			
			var classname = $input.attr('class');
			$input.attr('id', 'lead_'+newKey+'_'+classname);
			$input.attr('name', 'lead['+newKey+']['+classname+']');
			$input.val('');
			
			var classToAdd = $input.data('class');
			
			if(classToAdd){
				
				$input.addClass(classToAdd);
				
				if(classToAdd == 'e164Number'){
					SmartPhoneNumber.prepareOneField($input, preferredCountries, defaultCountryCode);
				}
				
			}
			
		});
		
		$newLead.hide().appendTo('#'+formID+' .leads').fadeIn(400);
		$('#'+formID+' .leads li:last input:first').trigger('focus');
		
		if($('#'+formID+' .leads>li').length > 1){
			$('#'+formID+' .leads li .removeLead').show();
			$('#'+formID+' .lead').addClass('leadRemoveable');
		}else{
			$('#'+formID+' .leads li .removeLead').hide();
			$('#'+formID+' .lead').removeClass('leadRemoveable');
		}
	},

	addContactToLeadForm: function(people, isRecursive){

		//
		if(people.email == undefined){
			return;
		}

		var isRecursive = isRecursive !== undefined;

		// Get empty fields .name (or fields in error state)
		var emptyName = $('#leadsFormDashboard .leads .form-input input.name').filter(function () {
			return (!this.value || $(this).hasClass('ui-state-error'));
		});

		// If there's not empty field to fill with data (we check isRecursive value to avoid infinite loop)
		if(emptyName.length == 0 && !isRecursive){

			// Add empty row
			AffiliationV2.addLead('leadsFormDashboard');
			// Recursive call to function with data
			AffiliationV2.addContactToLeadForm(people, true);

		} else if (emptyName.length > 0){

			// Get row to fill
			var leadForm = emptyName.first().parents('.lead');

			leadForm.find('.company').val(people.thirdname);
			leadForm.find('.name').val(people.name);
			leadForm.find('.email').val(people.email);

			if(people.formatted_tel !== ''){
				leadForm.find('.phone').val(people.formatted_tel);
			} else if (people.formatted_mobile !== ''){
				leadForm.find('.phone').val(people.formatted_mobile);
			}

		}

	},

	removeLead : function(elt, formID){
		$(elt).closest('li').fadeOut(400, function(){
			$(this).remove();
			
			if($('#'+formID+' .leads>li').length <= 1){
				$('#'+formID+' .leads li .removeLead').hide();
				$('#'+formID+' .leads li').removeClass('leadRemoveable');
			}
		});
	},
	
	detailAffiliate : function(affiliateid){
		
		var options = {
			title		: Loc.g('Détails commissions'),
			width		: 1000,
			buttons	: [
				{text : Loc.g('Fermer'), click : function(){$(this).dialog("close");}}
			],
			callback	: function(){}
		};
		
		MyWindow.load('affiliationv2', {action:'detailCommissions', affiliateid : affiliateid}, options);
	},

	onboardingInit : function() {

		var formId	= "invitstaffform";
        var options	= {
        	success:function(data){
				var formIsOk	= MyForm.processJson(data, "invitstaffform");
				if (formIsOk) {
					$('.well>#invitStep').fadeOut("slow", function(){
						$('#successStep').fadeIn("slow");
					});
				}
			},
			dataType:"json"
        };

		MyForm.prepare(formId, "onboarding", options, true);
	}
};
